import { useDispatch } from 'react-redux';
import { sampleSlice } from 'app/slices/sample.slice';
import { configureMiddleware } from 'app/config/middleware';
import { sessionSlice } from '@ui-core/session/sessionSlice';
import { mainNavSlice } from '@ui-core/navigation/mainNav/mainNavSlice';
import { headerSlice } from '@ui-core/header/headerSlice';
import { userDataSlice } from '@ui-core/components/drawerCommitment/userDataSlice';
import { commitmentDrawerSlice } from '@ui-core/components/drawerCommitment/DrawerCommitment.slice';
import { requestLinkedBusinessesSlice } from '@ui-core/components/AddEnterprise/requestLinkedBusinessesSlice';
import { permissionSlice } from '@ui-core';
import {
	combineReducers,
	configureStore,
	type PreloadedState,
} from '@reduxjs/toolkit';
import { env } from '@config';
import { vigilanciaSlice } from './pages/vigilancia/slices/vigilanciaSlice/vigilanciaSlice';
import { selSlice } from './pages/vigilancia/slices/selSlice/selSlice';
import { userSlice } from './pages/admin/slices/userSlice/userSlice';
import { adminPendingRequestsSlice } from './pages/admin/slices/adminPendingRequestSlice/adminPendingRequestsSlice';
const DEV = env.NODE_ENV !== 'test' && env.ENV !== 'prod';

export const rootReducer = combineReducers({
	[headerSlice.name]: headerSlice.reducer,
	[mainNavSlice.name]: mainNavSlice.reducer,
	[sessionSlice.name]: sessionSlice.reducer,
	[adminPendingRequestsSlice.name]: adminPendingRequestsSlice.reducer,
	[userSlice.name]: userSlice.reducer,
	[permissionSlice.name]: permissionSlice.reducer,
	[requestLinkedBusinessesSlice.name]: requestLinkedBusinessesSlice.reducer,
	[sampleSlice.name]: sampleSlice.reducer,
	[selSlice.name]: selSlice.reducer,
	[vigilanciaSlice.name]: vigilanciaSlice.reducer,
	[commitmentDrawerSlice.name]: commitmentDrawerSlice.reducer,
	[userDataSlice.name]: userDataSlice.reducer,
});

/**
 * Creates a redux store using redux toolkit
 */
export const AppStore = configureStore({
	middleware: configureMiddleware(DEV),
	devTools: DEV,
	reducer: {
		[headerSlice.name]: headerSlice.reducer,
		[mainNavSlice.name]: mainNavSlice.reducer,
		[sessionSlice.name]: sessionSlice.reducer,
		[adminPendingRequestsSlice.name]: adminPendingRequestsSlice.reducer,
		[userSlice.name]: userSlice.reducer,
		[permissionSlice.name]: permissionSlice.reducer,
		[requestLinkedBusinessesSlice.name]:
			requestLinkedBusinessesSlice.reducer,
		[sampleSlice.name]: sampleSlice.reducer,
		[selSlice.name]: selSlice.reducer,
		[vigilanciaSlice.name]: vigilanciaSlice.reducer,
		[commitmentDrawerSlice.name]: commitmentDrawerSlice.reducer,
		[userDataSlice.name]: userDataSlice.reducer,
	},
});

export type AppState = ReturnType<typeof AppStore.getState>;

export type AppDispatch = typeof AppStore.dispatch;

export const setupStore = (preloadedState?: PreloadedState<AppState>) => {
	return configureStore({
		reducer: rootReducer,
		preloadedState,
	});
};
export type AppStoreType = ReturnType<typeof setupStore>;

export const useAppDispatch = () => useDispatch();
